import useDJITelemetryHandler from '@/hooks/useDJITelemetryHandler';
import useWaitingRobotTimer from '@/hooks/useWaitingRobotTimer';

const useOrganizer = (robot) => {
  useWaitingRobotTimer(robot.id);
  useDJITelemetryHandler(robot);
};

export default useOrganizer;
